var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.757 2.99961L14.757 4.99961H5V18.9996H19V9.24261L21 7.24261V19.9996C21 20.2648 20.8946 20.5192 20.7071 20.7067C20.5196 20.8943 20.2652 20.9996 20 20.9996H4C3.73478 20.9996 3.48043 20.8943 3.29289 20.7067C3.10536 20.5192 3 20.2648 3 19.9996V3.99961C3 3.73439 3.10536 3.48004 3.29289 3.2925C3.48043 3.10497 3.73478 2.99961 4 2.99961H16.757ZM20.485 2.09961L21.9 3.51561L12.708 12.7076L11.296 12.7106L11.294 11.2936L20.485 2.09961Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.cfb14654e18956f814286fed82336186.svg";
export { ForwardRef as ReactComponent };